export const LOGIN_API = "/login"
export const LOGOUT_API = "/logout"
export const SIGNIN_API = "/rbac"
export const GET_GUEST_TOKEN = "/guest-token"
export const UOM_LISTING_API = "/getAllUnitOfMeasurements"
export const ADD_UOM_API = "/unitOfMeasurement"
export const USAGE_EVENT_TYPE_LISTING_API = "/usageEventTypes"
export const CHARGING_HISTORY_API = "/charging/history"
export const ADD_USAGE_EVENT_TYPE_API = "/usageEventType"
export const GET_UOM_BY__ID_API = "/getUnitOfMeasurement"
export const RESOURCE_LISTING_API = "/getAllResources"
export const GET_RESOURCE_BY__ID_API = "/getResource"
export const ADD_RESOURCE_API = "/resource"
export const DELETE_RESOURCE_API = "/deleteResource"
export const DELETE_CUSTOMER_API = "/deleteCustomer"
export const SERVICE_LISTING_API = "/getAllServices"
export const ADD_SERVICE_API = "/service"
export const GET_ALL_ATTRIBUTE_API = "/attributes"
export const GET_ALL_CHARGERULE_API = "/chargeRules"
export const GET_RESERVATION_ANALYTICS_API = "/reservations/analytics"
export const GET_RESERVATION_SUMMARY_API = "/reservations/summary"
export const GET_USAGE_STATISTICS_API = "/usage/statistics/customer"
export const GET_STATION_USAGE_API = "/stations/metrics/totalUsage"
export const GET_STATION_USAGE_TREND_API = "/stations/metrics/usage"
export const GET_STATION_USAGE_FORECAST_API = "/getForecast"

export const GET_STATION_REVENUE_TREND_API = "/stations/revenue"
export const CREATE_EDIT_GET_ATTRIBUTE_API = "/attribute"
export const CONFIG_API = "/config/query"
export const OFFER_LISTING_API = "/getAllOffers"
export const DELETE_OFFER_API = "/deleteOffer"
export const ADD_OFFER_API = "/offer"
export const GET_OFFER_API = "/getOffer"
export const UPDATE_OFFER_API = "/updateOffer"
export const STATION_LISTING_API ="/stations"
export const RESERVATION_LISTING_API = "/reservation/query"
export const UPDATE_RESERVATION_API = "/updateReservation"
export const POST_RESERVATION_API = "/reserve"
export const GET_RESERVATION_API = "/getReservation"
export const UNSUBSCRIBE_OFFER_API = "/unsubscribe"
export const REGISTER_CUSTOMER_API = "/registerCustomer"
export const CUSTOMER_LISTING_API = "/customer/query"
export const BALANCE_CONSUMED_API = "/balance/query"
export const CUSTOMER_EVENTS_API = "/events"
export const GET_CUSTOMER_API = "/customer"
export const SEARCH_CUSTOMER_API = "/customers"
export const RATE_USAGE_API = "/v2/rateUsage"
export const BALANCE_API = "/balance"
export const UPDATE_CUSTOMER_API = "/updateCustomer"
export const COUNTRIES_API = "/location"
export const DASHBOARD_METRICS_API = "/stations/metrics/customer"
export const DOCUMENT_UPLOAD_AND_EDIT_AND_DELETE_API = "/document"
export const LIST_DOCUMENTS_API = "/documents"
export const VERIFY_DOCUMENT_API = "/document/verify"
export const GET_BILLS_API = "/bills"
export const ORDERS_LIST_API = "/tmf-api/productOrderingManagement/v5/productOrder"
export const CANCEL_ORDER_API = "/tmf-api/productOrderingManagement/v5/cancelProductOrder"
export const DEVICE_API_LISTING ="/devices"
export const DEVICE_API = "/device"
export const DEVICE_UPDATE_API = "/document?updateFile=true"
export const PARTNER_LISTING_API = "/tmf-api/party/v4/organization?organizationType=Partner"
export const PARTNER_CREATE_API = "/partner"
export const EDIT_PARTNER_API = "/partner"
export const POLICY_LIST_API = "/commissionPolicy"
export const PARTNER_ALLLISTING_API = "/partner"
export const INVOICE_FOR_CUSTOMER_AND_LISTING_API = "/invoices"
export const INVOICE_STATISTICS_API = "/invoices/statistics"
export const DEVICE_MANAGEMENT_API="/devices?status=Unassigned"
export const CREATE_POLICY_API = "/commissionPolicy"
export const PAYMENT_API="/payment/history"
export const PAYMENT_HISTORY_API="/payment/history"
export const POPULAR_PLAN='/getPopularOffers'
export const STASTICAL_API='/statistics'
export const IMPORT_OFFER_DATA = '/loadProductPricing'
export const TOP_GROUP_METRICS_API = "metrics/top-group?unit=Meter&groupingAttribute=Team"
export const POLICY_LISTING_API='/policies'
export const POLICY_API='/policy'
export const MVNO_DASHBOARD_API="/statistics/customer"
export const USER_MANAGEMENT_API="/users"
export const USER_MANAGEMENT_CREATE_API="/user"
export const OPERATOR_ALLLISTING_API= "/getAllOperators"
export const OPERATOR_CREATE_AND_EDIT_API= "/operator"
export const RESET_PASSWORD_API = "/user/password/reset/url"
export const EXPIRY_CHECK_API = "/password/reset/expiry"
export const RESET_CREATE_PASSWORD_API = "/password/reset"
export const OPERATOR_GET_OPERATOR_API= "/getOperator"
export const SUBSCRIBE_API="/subscribe"
export const CUSTOMER_CHAT_AI= "/chat"
export const CHANGE_PLAN = "/changePlan"
export const GET_ALL_TASKS = "/tasks"
export const GET_TASK_BY_ID = "/task"
export const STATISTICS_OF_TASKS = "/statistics/task"
export const VIEW_API="/view"
export const GET_SERVICE = "/getService"
export const DEACTIVATE = "/deactivate"
export const ACTIVATE = "/activate"
export const SET_CREATE_PASSWORD_API = "/password/set"
export const EMAIL_VERIFICATION = "/user/email"
export const BULK_DELETE = "/bulkDelete"
export const FORGOT_PASSWORD="/password/forget"
export const RESEND_PASSWORD_LINK="/resend/link"
export const GET_ALL_DEFAULT_CONFIGURATION = "/getAllSystemDefaultConfigurations"
export const CREATE_CONFIG_OPERATOR = "/operatorConfiguration"
export const GET_OPERATOR_CONFIGURATION = "/getOperatorConfiguration"
export const UPDATE_OPERATOR_CONFIGURATION = "/updateOperatorConfiguration"
export const GET_CONFIGURATION = "/getConfiguration"
export const GET_ALL_SESSIONS = "/v2/sessions"
export const INITIATE_SESSION = "/v2/session/initiate"
export const UPDATE_SESSION = "/v2/session/update"
export const TERMINATE_SESSION = "/v2/session/terminate"
export const EVENT_TYPE = "/eventType"
export const ENQUIRY_CREATE = "/enquiry"
export const PREVIEW_ORDER = '/previewProductOrder'
export const UPDATE_PASSWORD_API = '/user/password'
export const RECHARGE_API = '/balance/recharge'
export const CURRENCY_API = '/currency'
export const QUOTA_MANAGEMENT_API="/quota"
export const QUOTA_MANAGEMENT_LIST="/getAllQuota"
export const RATING_GROUP_API="/servicemap"
export const RATING_GROUP_All="/servicemaps"
export const PEER_CONFIGURATION_API="/peerConfiguration"
export const MID_SESSION_LIST="/midsession-trigger/configs"
export const MID_SESSION="/midsession-trigger/config"
export const GET_ALL_USER_ROLES="/rolesWithUsers"
export const ROLE="/role"
export const GET_ALL_CATEGORY="/inventory/categories"
export const GET_SUBCATEGORY = (id) =>`/inventory/category/${id}`
export const CREATE_CATEGORY="/inventory/category"
export const CREATE_SUBCATEGORY = (...paths) =>`/inventory/category/subcategory/${paths.join("/")}`;
export const UPDATE_CATEGORY = (id) =>`/inventory/category/${id}`
export const UPDATE_SUBCATEGORY = (categoryId,...paths) =>`/inventory/category/subcategory/${categoryId}/${paths.join("/")}`;
export const DELETE_CATEGORY = (id) =>`/inventory/category/${id}`
export const DELETE_SUBCATEGORY = (categoryId,subCategoryId,) =>`/inventory/category/${categoryId}/subcategory/${subCategoryId}`;
export const GET_ALL_LOCATION="/inventory/locations"
export const CREATE_LOCATION="/inventory/location"
export const GET_LOCATION_TYPE = "/inventory/locations/types"
export const UPDATE_LOCATION = (id) =>`/inventory/location/${id}`
export const DELETE_LOCATION = (id) =>`/inventory/location/${id}`
export const CREATE_ITEM="/inventory/item"
export const GET_ITEMS = (first, offset) =>`/inventory/items?first=${first}&offset=${offset}`;
export const UPDATE_ITEM = (id) =>`/inventory/item/${id}`
export const DELETE_ITEM = (id) =>`/inventory/item/${id}`
export const GET_ITEM_BY_SKU = (id) =>`/inventory/item/${id}`
export const GET_ATTRIBUTE_BY_CATEGORY = (categories) =>`/attribute/category?categories=${categories}`;
export const GET_BRAND_BY_CATEGORY = (categories) =>`/inventory/item/brands?categoryPath=${categories}`;
export const GET_INVENTORY = (first, offset) =>`/inventory/transactions?first=${first}&offset=${offset}`;
export const GET_ALL_PRICEBOOK = (first, offset) => `/inventory/pricebooks?first=${first}&offset=${offset}`;
export const CREATE_PRICEBOOK="/inventory/pricebook"
export const UPDATE_PRICEBOOK = (id) =>`/inventory/pricebook/${id}`
export const DELETE_PRICEBOOK = (id) =>`/inventory/pricebook/${id}`
export const GET_ALL_PO=(first, offset, status) =>`/inventory/transactions/purchaseOrders?first=${first}&offset=${offset}&status=${status}`;
export const CREATE_PO="/inventory/transactions/purchaseOrder"
export const UPDATE_PO = (orderId, itemId) => `/inventory/transactions/purchaseOrder/${orderId}?itemId=${itemId}`
export const STOCK_IN_REQUEST_PO = (id) =>`/inventory/transactions/stockInRequest/${id}`
export const ADMIN_APPROVE_PO_REQUEST = (orderid, itemId) => `/inventory/transactions/POUpdate/${orderid}?itemId=${itemId}`;
export const STOCK_IN_CREATION_PO = (referenceId) => `/inventory/transactions/stockIn?referenceid=${referenceId}`;
export const GET_ALL_SO=(first, offset, status) =>`/inventory/transactions/salesOrders?first=${first}&offset=${offset}&status=${status}`;
export const CREATE_SO="/inventory/transactions/salesOrder"
export const UPDATE_SO = (orderId, itemId) => `/inventory/transactions/salesOrder/${orderId}?itemId=${itemId}`
export const STOCK_OUT_REQUEST_SO = (id) =>`/inventory/transactions/stockOutRequest/${id}`
export const ADMIN_APPROVE_SO_REQUEST = (orderid, itemId) => `/inventory/transactions/SOUpdate/${orderid}?itemId=${itemId}`;
export const STOCK_OUT_CREATION_SO = (referenceId) => `/inventory/transactions/stockOut?referenceid=${referenceId}`;
export const ADMIN_NOTIFICATION_SSE ="/notifications-sse"
export const GET_NOTIFICATION ="/notifications"
export const GET_ALL_TRANSFER=(first, offset, types) =>`/inventory/transactions?first=${first}&offset=${offset}&types=${types}`;
export const CREATE_TRANSFER= (referenceId) => `/inventory/transactions/transfer?referenceid=${referenceId}`;
export const CREATE_ADJUSTMENT= (referenceId) => `/inventory/transactions/adjustment?referenceid=${referenceId}`;
export const GET_ALL_TRANSFER_INVENTORY=(first, offset, itemId) =>`/inventory/transactions?first=${first}&offset=${offset}&itemId=${itemId}`;
export const UPDATE_NOTIFICATION="/notification"
export const DELETE_NOTIFICATION = (id) =>`/notification/${id}`

export const CREATE_PARTNER_OFFER = "api/partner-offers";
export const UPLOAD_PUBLIC_FILE = "api/public/upload";
export const GET_ALL_OFFER = (partnerId,page = 1,pageSize = 10,status = "active") =>`api/partner-offers/partner/${partnerId}?page=${page}&pageSize=${pageSize}&status=${status}`;
export const GET_ALL_OFFER_SEARCH = (partnerId, offerTitle = "") =>`api/partner-offers/partner/${partnerId}/search?offerTitle=${encodeURIComponent(offerTitle)}`;
export const UPDATE_PARTNER_OFFER = (id) =>`/api/partner-offers/${id}`;
export const DELETE_PARTNER_OFFER = (id) =>`/api/partner-offers/${id}`;

export const GET_ALL_CHARGING="/pricing/query"
export const GET_ALL_BPR_ONE="/stations-query"
export const GET_ALL_BPR_TWO="/pricing/query"


